import $ from 'jquery';
import ymapsLoader from 'ymaps';
import Api from '../util/Api';
import Popup from '../util/Popup';
import Cache from '../util/Cache';
import StoreService from '../service/StoreService';
import CitySelectionItem from '../template/CitySelectionItem';

const PopupCityManager = {
    location: {
        city: '',
        lat: '',
        lng: '',
        pdf: ''
    },
    getLocation() {
        this.location = Cache.get('location');
        this.refreshLocation();
        if (this.location === false) {
            Api.get('/api/geo/location/')
                .then((response) => {
                    this.setLocation(response.city, response.lat, response.lng, response.pdf);
                });
        }
    },
    setLocation(city, lat, lng) {
        this.location = {
            city,
            lat,
            lng,
        };
        Cache.set('location', this.location);
        this.refreshLocation();
        this.calcStores();
    },
    refreshLocation() {
        $('.city-search-example__city').text(this.location.city);
    },
    calcStores() {
        if (!StoreService.stores) {
            return;
        }
        const latCity = parseFloat(this.location.lat);
        const lngCity = parseFloat(this.location.lng);
        const stores = StoreService.stores.map(({ id, name, lat, lng, pdf }) => {
            const distance = this.calcDistance(
                latCity, lngCity,
                parseFloat(lat.replace(',', '.')), parseFloat(lng.replace(',', '.'))
            );

            const selected = id == StoreService.activeStore.id;

            return {
                id,
                name,
                lat,
                lng,
                distance,
                selected,
                pdf
            };
        }).sort((a, b) => (a.distance > b.distance ? 1 : -1));

        this.renderStores(stores);
    },
    round: (number, precision = 2) => {
        const parsedNum = parseFloat(number);
        // eslint-disable-next-line
        return +(Math.round(parsedNum + `e+${precision}`) + `e-${precision}`);
    },
    calcDistance(lat1, lng1, lat2, lng2) {
        if ((lat1 == lat2) && (lng1 == lng2)) {
            return 0;
        }
        const radlat1 = Math.PI * lat1 / 180;
        const radlat2 = Math.PI * lat2 / 180;
        const theta = lng1 - lng2;
        const radtheta = Math.PI * theta / 180;
        let dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
        if (dist > 1) {
            dist = 1;
        }
        dist = Math.acos(dist);
        dist = dist * 180 / Math.PI;
        dist = dist * 60 * 1.1515;
        // return parseInt(dist * 1.609344);
        // возьмем величину чуть побольше, дороги идут ненапрямую к городам
        return this.round(dist * 1.659344);
    },
    renderStores(stores) {
        const htmlStores = stores.map(store => CitySelectionItem(store));
        $('.city-selection__items').html(htmlStores);
    }
};

StoreService.getStores()
    .then(() => {
        PopupCityManager.calcStores();
    });
PopupCityManager.getLocation();

Popup.onShow('city', () => {
    PopupCityManager.calcStores();
});

// инициализация автокомплита
let ymaps = '';
ymapsLoader.load('https://api-maps.yandex.ru/2.1/?lang=en_US').then((maps) => {
    ymaps = maps;

    const suggestView = new ymaps.SuggestView($('.city-search__input')[0]);

    suggestView.events.add('select', (e) => {
        const locationName = e.get('item').value;

        $('.city-search__input').val('');
        $('.city-search-example__city').text(locationName);

        ymaps.geocode(locationName, {
            results: 1
        }).then((response) => {
            const coords = response.geoObjects.get(0).geometry.getCoordinates();
            PopupCityManager.setLocation(locationName, coords[0], coords[1]);
        });
    });
});

$('body').on('click', '.city-selection-item', function () {
    const id = $(this).attr('data-id');
    const selectedClass = 'city-selection-item--selected';
    if (id == StoreService.activeStore.id) {
        return;
    }

    StoreService.setStore($(this).attr('data-id'));

    $('.city-selection-item').removeClass(selectedClass);
    $(this).addClass(selectedClass);
});

StoreService.onChange((e) => {
    $('.header-city').text(e.name);
});
